// import React, { useState, useEffect, useRef } from "react";
// import { 
//   Container, 
//   Grid, 
//   Card, 
//   CardContent, 
//   Typography, 
//   Box, 
//   Button,
//   useMediaQuery,
//   IconButton,
//   Paper,
//   Divider
// } from "@mui/material";
// import { styled } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import PaymentIcon from "@mui/icons-material/Payment";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import SecurityIcon from "@mui/icons-material/Security";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// // Custom styled components with dark gradient backgrounds
// const FeatureCard = styled(Card)(({ theme, color, visible }) => ({
//   height: '100%',
//   transition: 'transform 0.5s ease-out, box-shadow 0.5s ease-out, opacity 0.8s ease-out',
//   overflow: 'visible',
//   display: 'flex',
//   flexDirection: 'column',
//   borderRadius: theme.spacing(2),
//   background: `linear-gradient(135deg, #1a1a2e 0%, ${color}99 100%)`,
//   opacity: visible ? 1 : 0,
//   transform: visible ? 'translateY(0)' : 'translateY(50px)',
//   '&:hover': {
//     transform: 'translateY(-12px) scale(1.03)',
//     boxShadow: `0 20px 30px -10px ${color}80`,
//   },
// }));

// const IconWrapper = styled(Box)(({ theme, color }) => ({
//   backgroundColor: color,
//   borderRadius: '50%',
//   padding: theme.spacing(1.5),
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   marginBottom: theme.spacing(2),
//   width: 64,
//   height: 64,
//   boxShadow: `0 8px 20px -4px ${color}90`,
//   transition: 'transform 0.3s ease-out',
//   '&:hover': {
//     transform: 'rotate(10deg)',
//   },
// }));

// const BenefitItem = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   marginBottom: theme.spacing(1.5),
//   transition: 'transform 0.2s ease',
//   '&:hover': {
//     transform: 'translateX(5px)',
//   }
// }));

// // Custom button with gradient hover effect
// const GradientButton = styled(Button)(({ theme, color }) => ({
//   color: '#fff',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: '-100%',
//     width: '100%',
//     height: '100%',
//     background: `linear-gradient(90deg, transparent, ${color}40, transparent)`,
//     transition: 'left 0.5s ease-out',
//   },
//   '&:hover': {
//     backgroundColor: `${color}30`,
//     '&::before': {
//       left: '100%',
//     }
//   }
// }));

// const FeaturesAndBenefits = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const [visible, setVisible] = useState([false, false, false]);
//   const cardRefs = useRef([]);

//   // Features data with enhanced colors for dark mode
//   const features = [
//     { 
//       title: "UPI Payments", 
//       icon: <PaymentIcon style={{ fontSize: 32 }} />,
//       color: "#6366f1", // brighter indigo for dark background
//       description: "Make instant payments directly from your bank account with our seamless UPI integration.",
//       benefits: [
//         "Zero transaction fees",
//         "Instant transfers",
//         "Secure encrypted payments"
//       ]
//     },
//     { 
//       title: "Bank Transfers", 
//       icon: <AccountBalanceIcon style={{ fontSize: 32 }} />,
//       color: "#38bdf8", // brighter blue for dark background
//       description: "Transfer funds between accounts with reliability and confidence.",
//       benefits: [
//         "Multiple bank support",
//         "Scheduled transfers",
//         "Transaction history"
//       ]
//     },
//     { 
//       title: "Secure Transactions", 
//       icon: <SecurityIcon style={{ fontSize: 32 }} />,
//       color: "#4ade80", // brighter green for dark background
//       description: "End-to-end encryption ensures your financial data stays protected at all times.",
//       benefits: [
//         "256-bit encryption",
//         "Two-factor authentication",
//         "Fraud detection systems"
//       ]
//     },
//   ];

//   // Intersection Observer setup for scroll animations
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const index = cardRefs.current.findIndex(ref => ref === entry.target);
          
//           // Staggered animation for cards
//           setTimeout(() => {
//             setVisible(prev => {
//               const newState = [...prev];
//               newState[index] = true;
//               return newState;
//             });
//           }, index * 200); // 200ms delay between each card
//         }
//       });
//     }, { threshold: 0.1 });

//     cardRefs.current.forEach(ref => {
//       if (ref) observer.observe(ref);
//     });

//     return () => {
//       cardRefs.current.forEach(ref => {
//         if (ref) observer.unobserve(ref);
//       });
//     };
//   }, []);

//   return (
//     <Box
//     id="Home-Section-Three"
//     sx={{ 
//       py: { xs: 6, md: 10 },
//       backgroundColor: '#0f172a', // Dark blue background
//       borderRadius: { md: 0 },
//       overflow: 'hidden',
//       position: 'relative'
//     }}>
//       {/* Animated background elements */}
//       <Box sx={{
//         position: 'absolute',
//         top: -100,
//         right: -100,
//         width: 300,
//         height: 300,
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, rgba(99,102,241,0) 70%)',
//         zIndex: 0,
//         animation: 'pulse 15s infinite alternate',
//         '@keyframes pulse': {
//           '0%': { opacity: 0.5, transform: 'scale(1)' },
//           '100%': { opacity: 0.8, transform: 'scale(1.2)' }
//         }
//       }} />
      
//       <Box sx={{
//         position: 'absolute',
//         bottom: -100,
//         left: -100,
//         width: 300,
//         height: 300,
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(56,189,248,0.15) 0%, rgba(56,189,248,0) 70%)',
//         zIndex: 0,
//         animation: 'float 20s infinite alternate',
//         '@keyframes float': {
//           '0%': { transform: 'translateY(0) scale(1)' },
//           '100%': { transform: 'translateY(50px) scale(1.1)' }
//         }
//       }} />

//       <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//         <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
//           <Typography 
//             variant="h2" 
//             component="h2" 
//             sx={{ 
//               fontSize: { xs: '2rem', md: '2.5rem' },
//               fontWeight: 700,
//               mb: 2,
//               color: '#ffffff',
//               textShadow: '0 2px 10px rgba(99,102,241,0.3)'
//             }}
//           >
//             Features & Benefits
//           </Typography>
          
//           <Typography 
//             variant="h6" 
//             color="rgba(255,255,255,0.7)"
//             sx={{ 
//               maxWidth: '800px', 
//               mx: 'auto',
//               px: 2,
//               fontSize: { xs: '1rem', md: '1.125rem' }
//             }}
//           >
//             Discover why our payment solution is trusted by millions of users worldwide
//           </Typography>
//         </Box>

//         <Grid container spacing={4}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} sm={6} md={4} key={index}>
//               <Box 
//                 ref={el => cardRefs.current[index] = el}
//                 sx={{ height: '100%' }}
//               >
//                 <FeatureCard 
//                   elevation={6} 
//                   color={feature.color}
//                   visible={visible[index]}
//                 >
//                   <CardContent sx={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     height: '100%',
//                     p: 3
//                   }}>
//                     <IconWrapper color={feature.color}>
//                       {React.cloneElement(feature.icon, {
//                         style: { color: '#fff', fontSize: 32 }
//                       })}
//                     </IconWrapper>
                    
//                     <Typography 
//                       variant="h5" 
//                       component="h3"
//                       sx={{ 
//                         fontWeight: 600, 
//                         mb: 1.5,
//                         fontSize: { xs: '1.25rem', md: '1.4rem' },
//                         color: '#ffffff'
//                       }}
//                     >
//                       {feature.title}
//                     </Typography>
                    
//                     <Typography 
//                       variant="body1" 
//                       color="rgba(255,255,255,0.7)"
//                       sx={{ mb: 3 }}
//                     >
//                       {feature.description}
//                     </Typography>
                    
//                     <Divider sx={{ my: 2, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    
//                     <Box sx={{ mt: 'auto' }}>
//                       {feature.benefits.map((benefit, idx) => (
//                         <BenefitItem key={idx}>
//                           <CheckCircleOutlineIcon 
//                             sx={{ 
//                               mr: 1.5, 
//                               color: feature.color,
//                               fontSize: 20
//                             }} 
//                           />
//                           <Typography variant="body2" color="rgba(255,255,255,0.85)">
//                             {benefit}
//                           </Typography>
//                         </BenefitItem>
//                       ))}
//                     </Box>
                    
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                       <GradientButton 
//                         endIcon={<ArrowForwardIcon />}
//                         color={feature.color}
//                       >
//                         Learn More
//                       </GradientButton>
//                     </Box>
//                   </CardContent>
//                 </FeatureCard>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// export default FeaturesAndBenefits;

// import React, { useState, useEffect, useRef } from "react";
// import { 
//   Container, 
//   Grid, 
//   Card, 
//   CardContent, 
//   Typography, 
//   Box, 
//   Button,
//   useMediaQuery,
//   IconButton,
//   Paper,
//   Divider
// } from "@mui/material";
// import { styled } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import SecurityIcon from "@mui/icons-material/Security";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import FlightIcon from "@mui/icons-material/Flight";
// import LiveTvIcon from "@mui/icons-material/LiveTv";
// import PaymentIcon from "@mui/icons-material/Payment";

// // Custom styled components with dark gradient backgrounds
// const FeatureCard = styled(Card)(({ theme, color, visible }) => ({
//   height: '100%',
//   transition: 'transform 0.5s ease-out, box-shadow 0.5s ease-out, opacity 0.8s ease-out',
//   overflow: 'visible',
//   display: 'flex',
//   flexDirection: 'column',
//   borderRadius: theme.spacing(2),
//   background: `linear-gradient(135deg, #1a1a2e 0%, ${color}99 100%)`,
//   opacity: visible ? 1 : 0,
//   transform: visible ? 'translateY(0)' : 'translateY(50px)',
//   '&:hover': {
//     transform: 'translateY(-12px) scale(1.03)',
//     boxShadow: `0 20px 30px -10px ${color}80`,
//   },
// }));

// const IconWrapper = styled(Box)(({ theme, color }) => ({
//   backgroundColor: color,
//   borderRadius: '50%',
//   padding: theme.spacing(1.5),
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   marginBottom: theme.spacing(2),
//   width: 64,
//   height: 64,
//   boxShadow: `0 8px 20px -4px ${color}90`,
//   transition: 'transform 0.3s ease-out',
//   '&:hover': {
//     transform: 'rotate(10deg)',
//   },
// }));

// const BenefitItem = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   marginBottom: theme.spacing(1.5),
//   transition: 'transform 0.2s ease',
//   '&:hover': {
//     transform: 'translateX(5px)',
//   }
// }));

// // Custom button with gradient hover effect
// const GradientButton = styled(Button)(({ theme, color }) => ({
//   color: '#fff',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: '-100%',
//     width: '100%',
//     height: '100%',
//     background: `linear-gradient(90deg, transparent, ${color}40, transparent)`,
//     transition: 'left 0.5s ease-out',
//   },
//   '&:hover': {
//     backgroundColor: `${color}30`,
//     '&::before': {
//       left: '100%',
//     }
//   }
// }));

// const FeaturesAndBenefits = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const [visible, setVisible] = useState([false, false, false, false, false]);
//   const cardRefs = useRef([]);

//   // Features data with enhanced colors for dark mode
//   const features = [
//     { 
//       title: "Travel Bookings", 
//       icon: <FlightIcon style={{ fontSize: 32 }} />,
//       color: "#6366f1", // brighter indigo for dark background
//       description: "Book all your travel needs in one place with our comprehensive travel services.",
//       benefits: [
//         "Bus & flight tickets",
//         "Hotel reservations",
//         "Movie ticket bookings"
//       ]
//     },
//     { 
//       title: "Utility Services", 
//       icon: <LiveTvIcon style={{ fontSize: 32 }} />,
//       color: "#f43f5e", // bright rose color
//       description: "Pay all your utility bills conveniently from one platform.",
//       benefits: [
//         "Electricity & water bills",
//         "Mobile recharges",
//         "Gas supply payments"
//       ]
//     },
//     { 
//       title: "Bank Transfers", 
//       icon: <AccountBalanceIcon style={{ fontSize: 32 }} />,
//       color: "#38bdf8", // brighter blue for dark background
//       description: "Transfer funds between accounts with reliability and confidence.",
//       benefits: [
//         "Salary payments",
//         "Office rent transfers",
//         "Transaction history"
//       ]
//     },
//     { 
//       title: "Secure Transactions", 
//       icon: <SecurityIcon style={{ fontSize: 32 }} />,
//       color: "#4ade80", // brighter green for dark background
//       description: "End-to-end encryption ensures your financial data stays protected at all times.",
//       benefits: [
//         "256-bit encryption",
//         "Two-factor authentication",
//         "Fraud detection systems"
//       ]
//     },
//     { 
//       title: "Business Payments", 
//       icon: <PaymentIcon style={{ fontSize: 32 }} />,
//       color: "#fb923c", // bright orange
//       description: "Manage all your business expenses and payments from a single dashboard.",
//       benefits: [
//         "Vendor payments",
//         "Automated invoicing",
//         "Expense tracking"
//       ]
//     },
//   ];

//   // Intersection Observer setup for scroll animations
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const index = cardRefs.current.findIndex(ref => ref === entry.target);
          
//           // Staggered animation for cards
//           setTimeout(() => {
//             setVisible(prev => {
//               const newState = [...prev];
//               newState[index] = true;
//               return newState;
//             });
//           }, index * 200); // 200ms delay between each card
//         }
//       });
//     }, { threshold: 0.1 });

//     cardRefs.current.forEach(ref => {
//       if (ref) observer.observe(ref);
//     });

//     return () => {
//       cardRefs.current.forEach(ref => {
//         if (ref) observer.unobserve(ref);
//       });
//     };
//   }, []);

//   return (
//     <Box
//     id="Home-Section-Three"
//     sx={{ 
//       py: { xs: 6, md: 10 },
//       backgroundColor: '#0f172a', // Dark blue background
//       borderRadius: { md: 0 },
//       overflow: 'hidden',
//       position: 'relative'
//     }}>
//       {/* Animated background elements */}
//       <Box sx={{
//         position: 'absolute',
//         top: -100,
//         right: -100,
//         width: 300,
//         height: 300,
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, rgba(99,102,241,0) 70%)',
//         zIndex: 0,
//         animation: 'pulse 15s infinite alternate',
//         '@keyframes pulse': {
//           '0%': { opacity: 0.5, transform: 'scale(1)' },
//           '100%': { opacity: 0.8, transform: 'scale(1.2)' }
//         }
//       }} />
      
//       <Box sx={{
//         position: 'absolute',
//         bottom: -100,
//         left: -100,
//         width: 300,
//         height: 300,
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(56,189,248,0.15) 0%, rgba(56,189,248,0) 70%)',
//         zIndex: 0,
//         animation: 'float 20s infinite alternate',
//         '@keyframes float': {
//           '0%': { transform: 'translateY(0) scale(1)' },
//           '100%': { transform: 'translateY(50px) scale(1.1)' }
//         }
//       }} />

//       <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//         <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
//           <Typography 
//             variant="h2" 
//             component="h2" 
//             sx={{ 
//               fontSize: { xs: '2rem', md: '2.5rem' },
//               fontWeight: 700,
//               mb: 2,
//               color: '#ffffff',
//               textShadow: '0 2px 10px rgba(99,102,241,0.3)'
//             }}
//           >
//             Features & Benefits
//           </Typography>
          
//           <Typography 
//             variant="h6" 
//             color="rgba(255,255,255,0.7)"
//             sx={{ 
//               maxWidth: '800px', 
//               mx: 'auto',
//               px: 2,
//               fontSize: { xs: '1rem', md: '1.125rem' }
//             }}
//           >
//             Discover why our payment solution is trusted by millions of users worldwide
//           </Typography>
//         </Box>

//         <Grid container spacing={4}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} sm={6} md={index === 4 ? 12 : 6} key={index}>
//               <Box 
//                 ref={el => cardRefs.current[index] = el}
//                 sx={{ height: '100%' }}
//               >
//                 <FeatureCard 
//                   elevation={6} 
//                   color={feature.color}
//                   visible={visible[index]}
//                 >
//                   <CardContent sx={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     height: '100%',
//                     p: 3
//                   }}>
//                     <IconWrapper color={feature.color}>
//                       {React.cloneElement(feature.icon, {
//                         style: { color: '#fff', fontSize: 32 }
//                       })}
//                     </IconWrapper>
                    
//                     <Typography 
//                       variant="h5" 
//                       component="h3"
//                       sx={{ 
//                         fontWeight: 600, 
//                         mb: 1.5,
//                         fontSize: { xs: '1.25rem', md: '1.4rem' },
//                         color: '#ffffff'
//                       }}
//                     >
//                       {feature.title}
//                     </Typography>
                    
//                     <Typography 
//                       variant="body1" 
//                       color="rgba(255,255,255,0.7)"
//                       sx={{ mb: 3 }}
//                     >
//                       {feature.description}
//                     </Typography>
                    
//                     <Divider sx={{ my: 2, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    
//                     <Box sx={{ mt: 'auto' }}>
//                       {feature.benefits.map((benefit, idx) => (
//                         <BenefitItem key={idx}>
//                           <CheckCircleOutlineIcon 
//                             sx={{ 
//                               mr: 1.5, 
//                               color: feature.color,
//                               fontSize: 20
//                             }} 
//                           />
//                           <Typography variant="body2" color="rgba(255,255,255,0.85)">
//                             {benefit}
//                           </Typography>
//                         </BenefitItem>
//                       ))}
//                     </Box>
                    
//                     {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                       <GradientButton 
//                         endIcon={<ArrowForwardIcon />}
//                         color={feature.color}
//                       >
//                         Learn More
//                       </GradientButton>
//                     </Box> */}
//                   </CardContent>
//                 </FeatureCard>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// export default FeaturesAndBenefits;

import React, { useState, useEffect, useRef } from "react";
import { 
  Container, 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Button,
  useMediaQuery,
  IconButton,
  Paper,
  Divider
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SecurityIcon from "@mui/icons-material/Security";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FlightIcon from "@mui/icons-material/Flight";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import PaymentIcon from "@mui/icons-material/Payment";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

// Custom styled components with dark gradient backgrounds
const FeatureCard = styled(Card)(({ theme, color, visible }) => ({
  height: '100%',
  transition: 'transform 0.5s ease-out, box-shadow 0.5s ease-out, opacity 0.8s ease-out',
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(2),
  background: `linear-gradient(135deg, #1a1a2e 0%, ${color}99 100%)`,
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0)' : 'translateY(50px)',
  '&:hover': {
    transform: 'translateY(-12px) scale(1.03)',
    boxShadow: `0 20px 30px -10px ${color}80`,
  },
}));

const ChartCard = styled(Card)(({ theme, visible }) => ({
  height: '100%',
  transition: 'transform 0.5s ease-out, box-shadow 0.5s ease-out, opacity 0.8s ease-out',
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(2),
  background: `linear-gradient(135deg, #1a1a2e 0%, #2a2a4e 100%)`,
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0)' : 'translateY(50px)',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 20px 30px -10px rgba(59, 130, 246, 0.5)',
  },
}));

const IconWrapper = styled(Box)(({ theme, color }) => ({
  backgroundColor: color,
  borderRadius: '50%',
  padding: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  width: 64,
  height: 64,
  boxShadow: `0 8px 20px -4px ${color}90`,
  transition: 'transform 0.3s ease-out',
  '&:hover': {
    transform: 'rotate(10deg)',
  },
}));

const BenefitItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
  transition: 'transform 0.2s ease',
  '&:hover': {
    transform: 'translateX(5px)',
  }
}));

// Custom button with gradient hover effect
const GradientButton = styled(Button)(({ theme, color }) => ({
  color: '#fff',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: `linear-gradient(90deg, transparent, ${color}40, transparent)`,
    transition: 'left 0.5s ease-out',
  },
  '&:hover': {
    backgroundColor: `${color}30`,
    '&::before': {
      left: '100%',
    }
  }
}));

const FeaturesAndBenefits = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [visible, setVisible] = useState([false, false, false, false, false, false]);
  const cardRefs = useRef([]);

  // Features data with enhanced colors for dark mode
  const features = [
    { 
      title: "Travel Bookings", 
      icon: <FlightIcon style={{ fontSize: 32 }} />,
      color: "#6366f1", // brighter indigo for dark background
      description: "Book all your travel needs in one place with our comprehensive travel services.",
      benefits: [
        "Bus & flight tickets",
        "Hotel reservations",
        "Movie ticket bookings"
      ]
    },
    { 
      title: "Utility Services", 
      icon: <LiveTvIcon style={{ fontSize: 32 }} />,
      color: "#f43f5e", // bright rose color
      description: "Pay all your utility bills conveniently from one platform.",
      benefits: [
        "Electricity & water bills",
        "Mobile recharges",
        "Gas supply payments"
      ]
    },
    { 
      title: "Bank Transfers", 
      icon: <AccountBalanceIcon style={{ fontSize: 32 }} />,
      color: "#38bdf8", // brighter blue for dark background
      description: "Transfer funds between accounts with reliability and confidence.",
      benefits: [
        "Salary payments",
        "Office rent transfers",
        "Transaction history"
      ]
    },
    { 
      title: "Secure Transactions", 
      icon: <SecurityIcon style={{ fontSize: 32 }} />,
      color: "#4ade80", // brighter green for dark background
      description: "End-to-end encryption ensures your financial data stays protected at all times.",
      benefits: [
        "256-bit encryption",
        "Two-factor authentication",
        "Fraud detection systems"
      ]
    },
    { 
      title: "Business Payments", 
      icon: <PaymentIcon style={{ fontSize: 32 }} />,
      color: "#fb923c", // bright orange
      description: "Manage all your business expenses and payments from a single dashboard.",
      benefits: [
        "Vendor payments",
        "Automated invoicing",
        "Expense tracking"
      ]
    },
  ];
  
  // Data for payment distribution charts
  const typicalPaymentsData = [
    { name: 'Vendors', value: 45, color: '#1e2b8c' },
    { name: 'GST', value: 12, color: '#4f5dc4' },
    { name: 'Office Rent', value: 10, color: '#5c6abe' },
    { name: 'Utilities', value: 5, color: '#6e77c7' },
    // { name: 'Statutory', value: 6, color: '#9194d0' },
    { name: 'Salary', value: 16, color: '#b5b8e1' },
    { name: 'Travel', value: 3, color: '#d1d4ed' },
    { name: 'Other Payments', value: 9, color: '#e6e9f7' },
  ];

  const creditCardPaymentsData = [
    { name: 'Vendors', value: 45, color: '#1e2b8c' },
    // { name: 'Card Accepting Vendors', value: 5, color: '#fdb913' },
    { name: 'GST', value: 12, color: '#4f5dc4' },
    { name: 'Office Rent', value: 10, color: '#5c6abe' },
    { name: 'Utilities', value: 5, color: '#6e77c7' },
    // { name: 'Statutory', value: 6, color: '#9194d0' },
    { name: 'Salary', value: 16, color: '#b5b8e1' },
    { name: 'Travel', value: 3, color: '#ffc74c' },
    { name: 'Other Payments', value: 9, color: '#e6e9f7' },
  ];

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.3;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="#ffffff" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        style={{ fontSize: '12px', fontWeight: 'bold' }}
      >
        {name} {value}%
      </text>
    );
  };

  // Intersection Observer setup for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = cardRefs.current.findIndex(ref => ref === entry.target);
          
          // Staggered animation for cards
          setTimeout(() => {
            setVisible(prev => {
              const newState = [...prev];
              newState[index] = true;
              return newState;
            });
          }, index * 200); // 200ms delay between each card
        }
      });
    }, { threshold: 0.1 });

    cardRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      cardRefs.current.forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <Box
    id="Home-Section-Three"
    sx={{ 
      py: { xs: 6, md: 10 },
      backgroundColor: '#0f172a', // Dark blue background
      borderRadius: { md: 0 },
      overflow: 'hidden',
      position: 'relative'
    }}>
      {/* Animated background elements */}
      <Box sx={{
        position: 'absolute',
        top: -100,
        right: -100,
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, rgba(99,102,241,0) 70%)',
        zIndex: 0,
        animation: 'pulse 15s infinite alternate',
        '@keyframes pulse': {
          '0%': { opacity: 0.5, transform: 'scale(1)' },
          '100%': { opacity: 0.8, transform: 'scale(1.2)' }
        }
      }} />
      
      <Box sx={{
        position: 'absolute',
        bottom: -100,
        left: -100,
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(56,189,248,0.15) 0%, rgba(56,189,248,0) 70%)',
        zIndex: 0,
        animation: 'float 20s infinite alternate',
        '@keyframes float': {
          '0%': { transform: 'translateY(0) scale(1)' },
          '100%': { transform: 'translateY(50px) scale(1.1)' }
        }
      }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
          <Typography 
            variant="h2" 
            component="h2" 
            sx={{ 
              fontSize: { xs: '2rem', md: '2.5rem' },
              fontWeight: 700,
              mb: 2,
              color: '#ffffff',
              textShadow: '0 2px 10px rgba(99,102,241,0.3)'
            }}
          >
            Features & Benefits
          </Typography>
          
          <Typography 
            variant="h6" 
            color="rgba(255,255,255,0.7)"
            sx={{ 
              maxWidth: '800px', 
              mx: 'auto',
              px: 2,
              fontSize: { xs: '1rem', md: '1.125rem' }
            }}
          >
            Discover why our payment solution is trusted by millions of users worldwide
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box 
                ref={el => cardRefs.current[index] = el}
                sx={{ height: '100%' }}
              >
                <FeatureCard 
                  elevation={6} 
                  color={feature.color}
                  visible={visible[index]}
                >
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    height: '100%',
                    p: 3
                  }}>
                    <IconWrapper color={feature.color}>
                      {React.cloneElement(feature.icon, {
                        style: { color: '#fff', fontSize: 32 }
                      })}
                    </IconWrapper>
                    
                    <Typography 
                      variant="h5" 
                      component="h3"
                      sx={{ 
                        fontWeight: 600, 
                        mb: 1.5,
                        fontSize: { xs: '1.25rem', md: '1.4rem' },
                        color: '#ffffff'
                      }}
                    >
                      {feature.title}
                    </Typography>
                    
                    <Typography 
                      variant="body1" 
                      color="rgba(255,255,255,0.7)"
                      sx={{ mb: 3 }}
                    >
                      {feature.description}
                    </Typography>
                    
                    <Divider sx={{ my: 2, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    
                    <Box sx={{ mt: 'auto' }}>
                      {feature.benefits.map((benefit, idx) => (
                        <BenefitItem key={idx}>
                          <CheckCircleOutlineIcon 
                            sx={{ 
                              mr: 1.5, 
                              color: feature.color,
                              fontSize: 20
                            }} 
                          />
                          <Typography variant="body2" color="rgba(255,255,255,0.85)">
                            {benefit}
                          </Typography>
                        </BenefitItem>
                      ))}
                    </Box>
                    
                    {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <GradientButton 
                        endIcon={<ArrowForwardIcon />}
                        color={feature.color}
                      >
                        Learn More
                      </GradientButton>
                    </Box> */}
                  </CardContent>
                </FeatureCard>
              </Box>
            </Grid>
          ))}

          {/* Payment Distribution Charts */}
          <Grid item xs={12} ref={el => cardRefs.current[5] = el}>
            <ChartCard elevation={6} visible={visible[5]}>
              <CardContent sx={{ p: 4 }}>
                <Typography 
                  variant="h4" 
                  component="h3"
                  sx={{ 
                    fontWeight: 600, 
                    mb: 3,
                    textAlign: 'center',
                    color: '#ffffff'
                  }}
                >
                  B2B Payment Distribution
                </Typography>

                <Grid container spacing={4}>
                  {/* First Chart */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                      <Typography 
                        variant="h5" 
                        color="#ffffff"
                        sx={{ fontWeight: 600 }}
                      >
                        Typical B2B Payments
                      </Typography>
                    </Box>
                    <Box sx={{ height: 350, position: 'relative' }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={typicalPaymentsData}
                            cx="50%"
                            cy="50%"
                            labelLine={true}
                            label={renderCustomizedLabel}
                            outerRadius={120}
                            innerRadius={60}
                            fill="#8884d8"
                            dataKey="value"
                          >
                            {typicalPaymentsData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip 
                            formatter={(value) => [`${value}%`, 'Percentage']}
                            contentStyle={{ backgroundColor: '#223', color: '#fff', borderRadius: '8px', border: 'none' }}
                          />
                        </PieChart>
                      </ResponsiveContainer>
                    </Box>
                  </Grid>

                  {/* Second Chart */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                      <Typography 
                        variant="h5" 
                        color="#ffffff"
                        sx={{ fontWeight: 600 }}
                      >
                        B2B Payments with Credit Cards
                      </Typography>
                    </Box>
                    <Box sx={{ height: 350, position: 'relative' }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={creditCardPaymentsData}
                            cx="50%"
                            cy="50%"
                            labelLine={true}
                            label={renderCustomizedLabel}
                            outerRadius={120}
                            innerRadius={60}
                            fill="#8884d8"
                            dataKey="value"
                          >
                            {creditCardPaymentsData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip 
                            formatter={(value) => [`${value}%`, 'Percentage']}
                            contentStyle={{ backgroundColor: '#223', color: '#fff', borderRadius: '8px', border: 'none' }}
                          />
                        </PieChart>
                      </ResponsiveContainer>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </ChartCard>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesAndBenefits;